export default __webpack_public_path__ + "static/media/7.48cae294.jpeg";